export default __webpack_public_path__ + "static/media/search.02f24786.svg";